import axios from 'axios'
import config from '../config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({ baseURL: baseUrl, timeout: 10000000, });

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

global.setting = { image : '', slogan : '', favicon : '' }
let custom_default = { image : '', slogan : '', favicon : '' }
const setting = () => global.setting
const Setting_Call = async () => {
  // support custom logo and slogan
  if(global.setting.slogan) { return; }
  try {
    let rs = await http.post('setting/custom', { target : 'settings', cmd : 'custom' })
    if(rs.error) { return console.error(rs.reason); }
    global.setting = Object.assign({}, global.setting, rs.body)
    custom_default.slogan = global.setting.slogan.toUpperCase()
    custom_default.image = global.setting.image
    custom_default.favicon = global.setting.favicon
    custom_default.manual = global.setting.manual

    document.title = `${global.setting.slogan} Manager`

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = custom_default.favicon;

    if(location.hostname == 'localhost') { console.log("[+] load cutom setting", global.setting.slogan) }
  } catch (e) { console.error(e) }
}
export default { setting, Setting_Call, custom_default }
